__turbopack_context__.v({
  "copyright": "RpDJNa_copyright",
  "footerFlexContainer": "RpDJNa_footerFlexContainer",
  "footerLinksContainer": "RpDJNa_footerLinksContainer",
  "legal": "RpDJNa_legal",
  "link": "RpDJNa_link",
  "linkSection": "RpDJNa_linkSection",
  "oneTrustLink": "RpDJNa_oneTrustLink",
  "signOffText": "RpDJNa_signOffText",
  "siteFooterPanel": "RpDJNa_siteFooterPanel",
  "siteLogo": "RpDJNa_siteLogo",
  "socialContainer": "RpDJNa_socialContainer",
  "socialLinks": "RpDJNa_socialLinks",
  "title": "RpDJNa_title",
});
